<page-header
  [title]="(editMode ? 'Edit ' : 'New ') + constants.strings.loyaltyCard"
  [subtitle]="subtitle"
></page-header>

<div
  style="display: flex; justify-content: flex-end; margin-bottom: 10px"
  *ngIf="canEditCard"
>
  <div style="display: flex">
    <app-primary-button
      [title]="constants.strings.cancel"
      border=" 1px solid var(--app-container)"
      bgColor="transparent"
      color="white"
      (tapped)="back()"
    ></app-primary-button>

    <div style="margin-left: 10px">
      <app-primary-button
        title="Save"
        [disabled]="loading || !canCreateCard"
        border=" 1px solid var(--app-container)"
        [tooltip]="tooltip"
        (tapped)="save()"
      ></app-primary-button>
    </div>
  </div>
</div>

<div *ngIf="isHandset$ | async" style="margin-bottom: 20px">
  <card-preview-container
    [textColour]="textColorFormControl.value"
    [cardColour]="cardColorFormControl.value"
    [stampColour]="stampFillColorFormControl.value"
    [stampFillEmpty]="stampFillEmptyFormControl.value"
    [stampOutlineColour]="stampColorFormControl.value"
    [stamps]="stampArray"
    [stampIcon]="stampIcon"
    [rewardIcon]="rewardIcon"
    [rewardIcons]="rewardIcons"
    [rewards]="rewards"
    [title]="titleFormControl.value"
    [description]="descriptionFormControl.value"
    [iconOpacity]="opacitySliderValue / 10"
    [iconColor]="iconColorFormControl.value"
    [showLogo]="showLogo"
    [showStamps]="showStamps"
    [shape]="shape"
    [cardGradient]="cardGradient ?? undefined"
    [stampImage]="stampImage?.content ?? card.stampImage?.url"
    [rewardImage]="rewardImage?.content ?? card.rewardImage?.url"
    [backgroundImage]="backgroundImage?.content ?? card.backgroundImage?.url"
    [backgroundImageOpacity]="bgImageOpacityValue / 10"
    [merchantLogo]="merchantLogo"
    [cardType]="cardTypeFormControl.value?.value"
    [currentPoints]="(totalPointsFormControl.value ?? 300) * 0.8"
    [totalPoints]="totalPointsFormControl.value ?? 300"
    [maxPoints]="maxPointsFormControl.value"
    [progressBarColor]="progressBarFormControl.value"
    [progressBarBgColor]="progressBarBgFormControl.value"
    [(bgImageOpacityValue)]="bgImageOpacityValue"
    [selectedTabIndex]="selectedIndex"
  >
    ></card-preview-container
  >
</div>

<form [formGroup]="form" *ngIf="!loading">
  <div class="main-container" style="margin-bottom: 70px">
    <div style="display: flex">
      <div
        style="display: flex; flex-direction: column"
        style="width: 100%; margin-right: 20px"
      >
        <div class="detail-container" id="left" style="display: flex">
          <mat-tab-group
            mat-align-tabs="start"
            mat-stretch-tabs="false"
            disableRipple="true"
            [animationDuration]="0"
            [(selectedIndex)]="selectedIndex"
            (selectedTabChange)="tabChanged($event.index)"
          >
            <mat-tab label="Overview">
              <div class="col-lg-7">
                <div class="form-field" style="margin-top: 20px">
                  <single-select
                    label="Card type"
                    [infoText]="cardTypeTooltip"
                    [formCtrl]="cardTypeFormControl"
                    [options]="cardTypeOptions"
                    [property]="'label'"
                    [inBrackets]="'info'"
                    [value]="cardTypeFormControl.value"
                    [disabled]="editMode"
                    (selected)="cardTypeSelected()"
                  >
                  </single-select>
                </div>

                <div class="form-field" style="margin-top: 20px">
                  <div class="form-field-label">
                    Title<span style="color: red">*</span>
                  </div>
                  <input
                    class="form-input"
                    [placeholder]="titlePlaceholder"
                    autocomplete="off"
                    [formControl]="titleFormControl"
                    maxlength="38"
                    type="text"
                    [ngStyle]="{
                      border:
                        titleFormControl.invalid && submitted
                          ? '1px solid red'
                          : '1px solid var(--app-light-grey)',
                    }"
                  />
                </div>

                <div class="form-field" style="margin-top: 20px">
                  <div class="form-field-label">
                    Description<span style="color: red">*</span>
                  </div>
                  <textarea
                    class="form-input"
                    autocomplete="off"
                    [formControl]="descriptionFormControl"
                    [placeholder]="descriptionPlaceholder"
                    type="text"
                    oninput="
                      javascript: if (this.value.length > this.maxLength)
                        this.value = this.value.slice(0, this.maxLength);
                    "
                    [maxlength]="78"
                    [rows]="2"
                    [ngStyle]="{
                      border:
                        descriptionFormControl.invalid && submitted
                          ? '1px solid red'
                          : '1px solid var(--app-light-grey)',
                    }"
                  ></textarea>
                </div>

                <div
                  class="form-field"
                  style="margin-top: 20px"
                  *ngIf="showCustomBrandingOption"
                >
                  <single-select
                    label="Display as"
                    [infoText]="displayAsTooltip"
                    [formCtrl]="fromFormControl"
                    [options]="fromOptions"
                    property="name"
                    [value]="fromFormControl.value"
                    (selected)="displayAsSelected($event)"
                  ></single-select>
                </div>

                <div
                  class="form-field"
                  *ngIf="(locations ?? []).length > 1"
                  style="margin-top: 20px"
                >
                  <multiple-select
                    label="Locations"
                    [formCtrl]="locationFormControl"
                    [options]="locations"
                    [disabled]="disabledLocations"
                    [showAll]="false"
                    infoText="Use this to restrict the locations which this card can be used at"
                    value="name"
                    (click)="hasLocations()"
                  >
                  </multiple-select>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Theme" *ngIf="hasSelectedCardType">
              <div
                class="form-field"
                style="margin-top: 20px; max-width: 420px"
              >
                <single-select
                  label="Theme Variant"
                  [formCtrl]="themeVariantFormControl"
                  [options]="themeVariantOptions"
                  property="label"
                  [value]="themeVariantFormControl.value"
                  (selected)="themeVariantSelected($event)"
                  [showTrailingAction]="showVariantEditAction"
                  trailingActionIcon="edit"
                  trailingActionTooltip="Edit variant settings"
                  [trailingActionDisabled]="!canEditSelectedThemeVariant"
                  (trailingActionTapped)="editSelectedVariantSettings()"
                  infoText="Create multiple theme variants to apply different themes to your card based on conditions (e.g. customer email address)"
                ></single-select>
              </div>

              <div class="form-field" style="margin-top: 20px">
                <div class="form-field-label">Colours</div>

                <div style="display: flex; margin-top: 10px">
                  <div
                    class="colour-container"
                    style="margin-right: 20px"
                    *ngIf="isStampCard"
                  >
                    <div
                      class="colour-avatar picker"
                      style="width: 35px; height: 35px"
                      [ngStyle]="{
                        'background-color': iconColorFormControl.value,
                      }"
                    >
                      <input
                        type="color"
                        [value]="iconColorFormControl.value"
                        (input)="onColorInput($event, iconColorFormControl)"
                      />
                    </div>
                    <div class="colour-label">Icons</div>
                  </div>

                  <div
                    class="colour-container"
                    style="margin-right: 20px"
                    *ngIf="isPointsCard"
                  >
                    <div
                      class="colour-avatar picker"
                      style="width: 35px; height: 35px"
                      [ngStyle]="{
                        'background-color': progressBarFormControl.value,
                      }"
                    >
                      <input
                        type="color"
                        [value]="progressBarFormControl.value"
                        (input)="onColorInput($event, progressBarFormControl)"
                      />
                    </div>
                    <div class="colour-label">Progress Bar</div>
                  </div>

                  <div class="colour-container" style="margin-right: 20px">
                    <div
                      [mat-menu-trigger-for]="colorMenu"
                      class="colour-avatar"
                      [ngStyle]="
                        cardColorFormControl.value
                          ? {
                              background: cardColorFormControl.value,
                              cursor: 'pointer',
                            }
                          : {
                              background:
                                'linear-gradient(' +
                                cardGradient?.angle +
                                'deg, ' +
                                cardGradient?.from +
                                ' ' +
                                0 +
                                '%, ' +
                                cardGradient?.from +
                                ' ' +
                                cardGradient?.value +
                                '%, ' +
                                cardGradient?.to +
                                ' ' +
                                100 +
                                '%)',
                              cursor: 'pointer',
                            }
                      "
                    ></div>
                    <div class="colour-label">Card</div>
                  </div>

                  <div class="colour-container" style="margin-right: 20px">
                    <div
                      class="colour-avatar picker"
                      style="width: 35px; height: 35px"
                      [ngStyle]="{
                        'background-color': textColorFormControl.value,
                      }"
                    >
                      <input
                        type="color"
                        [value]="textColorFormControl.value"
                        (input)="onColorInput($event, textColorFormControl)"
                      />
                    </div>

                    <div class="colour-label">Text</div>
                  </div>
                </div>

                <div style="display: flex; margin-top: 10px">
                  <div
                    class="colour-container"
                    style="margin-right: 20px"
                    *ngIf="isStampCard"
                  >
                    <div
                      [mat-menu-trigger-for]="stampOutlineMenu"
                      class="colour-avatar"
                      [ngStyle]="{
                        'background-color': stampColorFormControl.value
                          ? stampColorFormControl.value
                          : 'transparent',
                        cursor: 'pointer',
                      }"
                    ></div>

                    <div class="colour-label">Stamp outline</div>
                  </div>
                  <div
                    class="colour-container"
                    style="margin-right: 20px"
                    *ngIf="isPointsCard"
                  >
                    <div
                      class="colour-avatar picker"
                      style="width: 35px; height: 35px"
                      [ngStyle]="{
                        'background-color': progressBarBgFormControl.value,
                      }"
                    >
                      <input
                        type="color"
                        [value]="progressBarBgFormControl.value"
                        (input)="onColorInput($event, progressBarBgFormControl)"
                      />
                    </div>
                    <div class="colour-label">Progress Bar (Background)</div>
                  </div>

                  <div
                    class="colour-container"
                    style="margin-right: 20px"
                    *ngIf="isStampCard"
                  >
                    <div
                      [mat-menu-trigger-for]="stampFillMenu"
                      class="colour-avatar"
                      [ngStyle]="{
                        'background-color': stampFillColorFormControl.value
                          ? stampFillColorFormControl.value
                          : 'transparent',
                        cursor: 'pointer',
                      }"
                    ></div>
                    <div class="colour-label">Stamp fill</div>
                  </div>

                  <div
                    class="colour-container"
                    style="margin-right: 20px"
                    *ngIf="isStampCard"
                  >
                    <div
                      [mat-menu-trigger-for]="stampFillEmptyMenu"
                      class="colour-avatar"
                      [ngStyle]="{
                        'background-color': stampFillEmptyFormControl.value
                          ? stampFillEmptyFormControl.value
                          : 'transparent',
                        cursor: 'pointer',
                      }"
                    ></div>
                    <div class="colour-label">Stamp fill (pre stamp)</div>
                  </div>
                </div>
              </div>

              <div
                class="form-field"
                style="margin-top: 20px"
                *ngIf="isStampCard"
              >
                <hr />
                <div class="form-field-label">Stamp shape</div>

                <div style="display: flex; margin-top: 10px">
                  <div
                    class="shape-container"
                    style="margin-right: 20px"
                    (click)="shape = shapesEnum.square"
                  >
                    <div
                      class="shape-avatar-outer"
                      [ngStyle]="{
                        'border-radius': borderRadius(shapesEnum.square),
                        'border-color':
                          shape === shapesEnum.square
                            ? selectedShapeBorderColor
                            : '',
                      }"
                    >
                      <div
                        class="shape-avatar"
                        [ngStyle]="{
                          'border-radius': borderRadius(shapesEnum.square),
                        }"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="shape-container"
                    style="margin-right: 20px"
                    (click)="shape = shapesEnum.circle"
                  >
                    <div
                      class="shape-avatar-outer"
                      [ngStyle]="{
                        'border-radius': borderRadius(shapesEnum.circle),
                        'border-color':
                          shape === shapesEnum.circle
                            ? selectedShapeBorderColor
                            : '',
                      }"
                    >
                      <div
                        class="shape-avatar"
                        [ngStyle]="{
                          'border-radius': borderRadius(shapesEnum.circle),
                        }"
                      ></div>
                    </div>
                  </div>
                  <div
                    class="shape-container"
                    style="margin-right: 20px"
                    (click)="shape = shapesEnum.rounded"
                  >
                    <div
                      class="shape-avatar-outer"
                      [ngStyle]="{
                        'border-radius': borderRadius(shapesEnum.rounded),
                        'border-color':
                          shape === shapesEnum.rounded
                            ? selectedShapeBorderColor
                            : '',
                      }"
                    >
                      <div
                        class="shape-avatar"
                        [ngStyle]="{
                          'border-radius': borderRadius(shapesEnum.rounded),
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="form-field"
                style="margin-top: 20px"
                *ngIf="isStampCard"
              >
                <hr />
                <div class="form-field-label">Icons</div>
                <div style="display: flex; margin-top: 10px">
                  <div class="colour-container" style="margin-right: 20px">
                    <div
                      class="icon-avatar"
                      (click)="openIconPickerDialog(false)"
                    >
                      <mat-icon
                        *ngIf="!stampImage?.content && !card.stampImage?.url"
                        class="icon"
                        [fontSet]="
                          stampIcon?.filled
                            ? 'material-icons'
                            : 'material-icons-outlined'
                        "
                        >{{ stampIcon?.web }}</mat-icon
                      >
                      <img
                        *ngIf="stampImage?.content || card.stampImage?.url"
                        style="width: 25px; height: 25px"
                        [src]="stampImage?.content ?? card.stampImage?.url"
                      />
                    </div>
                    <div class="colour-label">Stamp</div>
                  </div>
                  <div class="colour-container" style="margin-right: 20px">
                    <div
                      class="icon-avatar"
                      (click)="openIconPickerDialog(true)"
                    >
                      <mat-icon
                        *ngIf="!rewardImage?.content && !card.rewardImage?.url"
                        class="icon"
                        [fontSet]="
                          rewardIcon?.filled
                            ? 'material-icons'
                            : 'material-icons-outlined'
                        "
                        >{{ rewardIcon?.web }}</mat-icon
                      >
                      <img
                        *ngIf="rewardImage?.content || card.rewardImage?.url"
                        style="width: 25px; height: 25px"
                        [src]="rewardImage?.content ?? card.rewardImage?.url"
                      />
                    </div>
                    <div class="colour-label">Reward</div>
                  </div>
                </div>
              </div>

              <div class="form-field" style="margin-top: 20px">
                <hr />
                <div class="form-field-label">Background Image</div>
                <div
                  style="
                    font-size: 12px;
                    color: var(--app-text-grey);
                    margin-top: 5px;
                  "
                >
                  Upload a background image (16:9 aspect ratio recommended)
                </div>
                <div
                  style="margin-top: 10px"
                  class="background-image-container"
                >
                  <file-upload
                    [aspectRatio]="16 / 9"
                    (fileSelected)="backgroundImage = $event[0]"
                    [readerResult]="
                      backgroundImage?.content ??
                      card.backgroundImage?.url ??
                      ''
                    "
                    [maxFileSize]="5242880"
                  ></file-upload>
                  <button
                    *ngIf="
                      backgroundImage?.content || card.backgroundImage?.url
                    "
                    mat-icon-button
                    color="warn"
                    class="delete-background-button"
                    (click)="deleteBackgroundImage()"
                  >
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>
              </div>
            </mat-tab>

            <mat-tab
              [label]="isStampCard ? 'Stamping' : 'Points'"
              *ngIf="hasSelectedCardType"
            >
              <div style="overflow: hidden">
                <div class="row" *ngIf="isStampCard">
                  <div class="col-lg-4">
                    <div class="form-field" style="margin-top: 20px">
                      <single-select
                        label="Total stamps"
                        [infoText]="requiredStampsTooltip"
                        [formCtrl]="totalStampsFormControl"
                        [options]="totalStampsOptions"
                        [value]="totalStampsFormControl.value"
                        (selected)="updateStampOptions($event)"
                      >
                      </single-select>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-field" style="margin-top: 20px">
                      <single-select
                        label="Join stamps"
                        infoText="The initial number of free stamps your customers should receive upon taking your Stamp Card. Choose 0 for no joining stamps"
                        [formCtrl]="joinStampsFormControl"
                        [options]="joinStampsOptions"
                        [value]="joinStampsFormControl.value"
                      >
                      </single-select>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-field" style="margin-top: 20px">
                      <single-select
                        label="Stamps per scan"
                        infoText="The number of stamps to be awarded by a single scan"
                        [formCtrl]="stampsPerScanStampsFormControl"
                        [options]="stampsPerScanOptions"
                        [value]="stampsPerScanStampsFormControl.value"
                      >
                      </single-select>
                      <p
                        class="revert-string"
                        *ngIf="card?.stampPromo"
                        (click)="openCampaigns()"
                      >
                        Promotion Enabled
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="!isStampCard">
                  <div class="col-lg-4">
                    <div
                      class="form-field"
                      style="margin-top: 20px"
                      *ngIf="isPointsCard"
                    >
                      <div class="form-field-label">
                        Total points<span style="color: red">*</span
                        ><info-icon [text]="availablePointsTooltip"></info-icon>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. 300"
                        [formControl]="totalPointsFormControl"
                        type="number"
                        (change)="totalPointsChanged()"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                        [ngStyle]="{
                          border:
                            totalPointsFormControl.invalid && submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      />
                    </div>
                    <div
                      class="form-field"
                      style="margin-top: 20px"
                      *ngIf="isOpenEndedPointsCard"
                    >
                      <div class="form-field-label">
                        Max points<info-icon
                          [text]="maxPointsTooltip"
                        ></info-icon>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="(leave empty for no limit)"
                        [formControl]="maxPointsFormControl"
                        type="number"
                        (change)="maxPointsChanged()"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                      />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">
                        Join points<span style="color: red">*</span
                        ><span
                          ><info-icon
                            text="The initial number of points your customers should receive upon taking your Loyalty Card. Choose 0 for no joining points"
                          ></info-icon
                        ></span>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. 20"
                        [formControl]="joinPointsFormControl"
                        type="number"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                      />
                    </div>
                  </div>

                  <div class="col-lg-4" *ngIf="isPointsCard">
                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">
                        Points per scan<span style="color: red">*</span
                        ><info-icon
                          text="The number of points to be awarded by a single NFC scan (you can still give a different number of points from the Portal or the Connect app)"
                        ></info-icon>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. 20"
                        [formControl]="pointsPerScanFormControl"
                        type="number"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                        [ngStyle]="{
                          border:
                            pointsPerScanFormControl.invalid && submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      />
                      <p
                        class="revert-string"
                        *ngIf="card?.stampPromo"
                        (click)="openCampaigns()"
                      >
                        Promotion Enabled
                      </p>
                    </div>
                  </div>

                  <div class="col-lg-4" *ngIf="isOpenEndedPointsCard">
                    <div class="form-field" style="margin-top: 20px">
                      <single-select
                        label="Points basis"
                        [formCtrl]="pointsBasisFormControl"
                        [value]="pointsBasisFormControl.value"
                        [options]="pointsBasisOptions"
                        property="name"
                        [showIcon]="true"
                        [inBrackets]="'info'"
                        [webIcon]="true"
                        (selected)="pointsBasisSelected()"
                      ></single-select>
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="isOpenEndedPointsCard">
                  <div class="col-lg-4">
                    <div
                      class="form-field"
                      style="margin-top: 20px"
                      *ngIf="
                        pointsBasisFormControl.value?.value === 'transaction'
                      "
                    >
                      <div class="form-field-label">
                        Number of points<span style="color: red">*</span
                        ><info-icon
                          text="The default number of points to be awarded by a single NFC scan (you can still give a different number of points from the Portal or the Connect app)"
                        ></info-icon>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. 20"
                        [formControl]="pointsPerScanFormControl"
                        type="number"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                        [ngStyle]="{
                          border:
                            pointsPerScanFormControl.invalid && submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      />
                    </div>

                    <div
                      class="form-field"
                      style="margin-top: 20px"
                      *ngIf="pointsBasisFormControl.value?.value === 'value'"
                    >
                      <single-select
                        label="Earning Method"
                        [formCtrl]="pointsEarningMethodFormControl"
                        [value]="pointsEarningMethodFormControl.value"
                        [options]="pointsEarningMethodOptions"
                        property="name"
                        [showIcon]="true"
                        [inBrackets]="'info'"
                        [webIcon]="true"
                      ></single-select>
                    </div>
                  </div>

                  <div
                    class="col-lg-4"
                    *ngIf="pointsBasisFormControl.value?.value === 'value'"
                  >
                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">
                        {{
                          pointsEarningMethodFormControl.value?.value ===
                          "fixed"
                            ? "Spend threshold"
                            : "Spend"
                        }}<span style="color: red">*</span
                        ><info-icon [text]="spendInfo"></info-icon>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. 20"
                        [formControl]="valueFormControl"
                        type="number"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                        [ngStyle]="{
                          border:
                            valueFormControl.invalid && submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      />
                    </div>
                  </div>

                  <div
                    class="col-lg-4"
                    *ngIf="pointsBasisFormControl.value?.value === 'value'"
                  >
                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">
                        Number of points<span style="color: red">*</span
                        ><info-icon
                          [text]="
                            pointsEarningMethodFormControl.value?.value ===
                            'fixed'
                              ? valuePointsInfoFixed
                              : valuePointsInfoIncremental
                          "
                        ></info-icon>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. 20"
                        [formControl]="pointsPerScanFormControl"
                        type="number"
                        [maxlength]="7"
                        oninput="
                          javascript: if (this.value.length > this.maxLength)
                            this.value = this.value.slice(0, this.maxLength);
                        "
                        [ngStyle]="{
                          border:
                            pointsPerScanFormControl.invalid && submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      />
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="!isStampCard" style="margin-top: 20px">
                  <div class="col-lg-8">
                    <div
                      class="form-field"
                      style="display: flex; justify-content: space-between"
                    >
                      <div class="form-field-label">
                        Points have an expiry date
                      </div>
                      <mat-slide-toggle
                        [disabled]="!canEditCard"
                        [checked]="pointsExpire"
                        (change)="pointsExpire = !pointsExpire"
                      >
                      </mat-slide-toggle>
                    </div>

                    <div class="form-field" *ngIf="pointsExpire">
                      <div style="width: 100%">
                        <div class="form-field-label">
                          Expiry<span style="color: red">*</span
                          ><span
                            ><info-icon
                              text="The expiration period for the points, measured in days from the time the customer receives them"
                            ></info-icon>
                          </span>
                        </div>
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            flex-direction: row;
                            align-items: center;
                          "
                        >
                          <input
                            class="form-input"
                            autocomplete="off"
                            placeholder="e.g. 14"
                            [formControl]="pointsExpiryFormControl"
                            type="number"
                            [maxlength]="4"
                            min="0"
                            oninput="
                              javascript: if (
                                this.value.length > this.maxLength
                              )
                                this.value = this.value.slice(
                                  0,
                                  this.maxLength,
                                );
                            "
                          />
                          <div
                            class="form-field-label"
                            style="width: 50px; padding-left: 10px"
                          >
                            days
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-8">
                    <hr />
                    <div
                      class="form-field"
                      style="
                        margin-top: 20px;
                        display: flex;
                        justify-content: space-between;
                      "
                    >
                      <div class="form-field-label">
                        {{
                          isStampCard
                            ? "Daily stamp restriction"
                            : "Daily points restriction"
                        }}
                      </div>
                      <mat-slide-toggle
                        [disabled]="!canEditCard"
                        [checked]="stampsPerDay"
                        (change)="stampsPerDay = !stampsPerDay"
                      >
                      </mat-slide-toggle>
                    </div>

                    <div
                      class="form-field"
                      style="margin-left: 10px; margin-right: 10px"
                      *ngIf="stampsPerDay"
                    >
                      <div style="width: 100%">
                        <div class="form-field-label">
                          {{
                            isStampCard
                              ? "Max stamps per day"
                              : "Max points per day"
                          }}<span style="color: red">*</span
                          ><span
                            ><info-icon [text]="restrictionTooltip"></info-icon>
                          </span>
                        </div>
                        <div
                          style="
                            display: flex;
                            justify-content: space-between;
                            flex-direction: row;
                            align-items: center;
                          "
                        >
                          <input
                            class="form-input"
                            autocomplete="off"
                            [placeholder]="isStampCard ? 'e.g. 1' : 'e.g. 100'"
                            [formControl]="stampsPerDayStampsFormControl"
                            type="number"
                            [maxlength]="5"
                            oninput="
                              javascript: if (
                                this.value.length > this.maxLength
                              )
                                this.value = this.value.slice(
                                  0,
                                  this.maxLength,
                                );
                            "
                          />
                          <div
                            class="form-field-label-subtitle"
                            style="
                              width: 60px;
                              padding-left: 10px;
                              margin-bottom: 0px;
                            "
                          >
                            {{ isStampCard ? "stamps" : "points" }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-8">
                    <hr *ngIf="stampsPerDay" />
                    <div
                      class="form-field"
                      style="
                        margin-top: 20px;
                        display: flex;
                        justify-content: space-between;
                      "
                    >
                      <div class="form-field-label">Interval restriction</div>
                      <mat-slide-toggle
                        [disabled]="!canEditCard"
                        [checked]="interval"
                        (change)="interval = !interval"
                      >
                      </mat-slide-toggle>
                    </div>

                    <div
                      class="form-field"
                      style="margin-left: 10px; margin-right: 10px"
                      *ngIf="interval"
                    >
                      <div class="form-field-label">
                        {{
                          isStampCard
                            ? "Time between stamps"
                            : "Time between points"
                        }}<span style="color: red">*</span
                        ><span
                          ><info-icon
                            [text]="intervalRestrictionTooltip"
                          ></info-icon>
                        </span>
                      </div>

                      <div class="row">
                        <div class="col-lg-6">
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              flex-direction: row;
                              align-items: center;
                              margin-bottom: 10px;
                            "
                          >
                            <input
                              class="form-input"
                              autocomplete="off"
                              placeholder="e.g. 1"
                              [formControl]="intervalHoursFormControl"
                              type="number"
                              [maxlength]="2"
                              oninput="
                                javascript: if (
                                  this.value.length > this.maxLength
                                )
                                  this.value = this.value.slice(
                                    0,
                                    this.maxLength,
                                  );
                              "
                            />
                            <div
                              class="form-field-label-subtitle"
                              style="
                                width: 60px;
                                padding-left: 10px;
                                margin-bottom: 0px;
                              "
                            >
                              hours
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div
                            style="
                              display: flex;
                              justify-content: space-between;
                              flex-direction: row;
                              align-items: center;
                            "
                          >
                            <input
                              class="form-input"
                              autocomplete="off"
                              placeholder="e.g. 30"
                              [formControl]="intervalMinutesFormControl"
                              type="number"
                              [maxlength]="2"
                              oninput="
                                javascript: if (
                                  this.value.length > this.maxLength
                                )
                                  this.value = this.value.slice(
                                    0,
                                    this.maxLength,
                                  );
                              "
                            />
                            <div
                              class="form-field-label-subtitle"
                              style="
                                width: 60px;
                                padding-left: 10px;
                                margin-bottom: 0px;
                              "
                            >
                              minutes
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-8" *ngIf="interval || stampsPerDay">
                    <hr *ngIf="interval" />
                    <div
                      class="form-field"
                      style="
                        margin-top: 20px;
                        display: flex;
                        justify-content: space-between;
                      "
                    >
                      <div class="form-field-label">
                        Remy Connect Override<span
                          ><info-icon
                            [text]="connectOverrideTooltip"
                          ></info-icon>
                        </span>
                      </div>
                      <mat-slide-toggle
                        [disabled]="!canEditCard"
                        [checked]="connectOverride"
                        (change)="connectOverride = !connectOverride"
                      >
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab
              label="Rewards"
              *ngIf="hasSelectedCardType && canSelectReward"
            >
              <div
                style="
                  overflow: hidden;
                  display: flex;
                  flex-direction: column;
                  gap: 20px;
                  margin-top: 20px;
                "
                class="rewards-container"
              >
                <!-- How to Earn Section (Mobile First) -->
                <div
                  class="how-to-earn-section"
                  style="flex: 1; order: 1"
                  *ngIf="isOpenEndedPointsCard || isPointsCard"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 20px;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <div
                        class="form-field-label"
                        style="
                          margin-bottom: 0px;
                          margin-right: 5px;
                          font-size: 16px;
                          font-weight: 600;
                        "
                      >
                        How to Earn
                      </div>

                      <mat-icon
                        class="status-icon"
                        style="color: var(--app-timber); cursor: pointer"
                        (click)="openEarningMethodDialog()"
                        >add_circle</mat-icon
                      >
                    </div>
                  </div>

                  <div
                    *ngFor="let item of earningMethods; let i = index"
                    style="margin-top: 10px"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          justify-content: space-between;
                          margin-right: 20px;
                        "
                        class="social-container"
                      >
                        <div style="display: flex; align-items: center">
                          <div
                            class="form-field-label"
                            style="
                              margin-bottom: 0px !important;
                              color: black;
                              font-size: 16px;
                              margin-right: 5px;
                            "
                          >
                            {{ item.pointsAwarded }}:
                          </div>
                          <div
                            class="form-field-label"
                            style="
                              margin-bottom: 0px !important;
                              color: black;
                              font-size: 16px;
                            "
                          >
                            {{ item.title }}
                          </div>
                        </div>

                        <div
                          style="display: flex; align-items: center; gap: 5px"
                        >
                          <mat-icon
                            style="color: var(--app-timber); cursor: pointer"
                            (click)="editEarningMethod(item)"
                            >edit
                          </mat-icon>
                          <mat-icon
                            style="color: red; cursor: pointer"
                            (click)="removeEarningMethod(item)"
                            >cancel
                          </mat-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="earningMethods.length === 0"
                    style="color: #666; font-style: italic; margin-top: 20px"
                  >
                    No earning methods configured. Click the + icon to add one.
                  </div>
                </div>

                <!-- Redeemable Rewards Section -->
                <div
                  class="redeemable-rewards-section"
                  style="flex: 1; order: 2"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 20px;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <div
                        class="form-field-label"
                        style="
                          margin-bottom: 0px;
                          margin-right: 5px;
                          font-size: 16px;
                          font-weight: 600;
                        "
                      >
                        Redeemable Rewards
                      </div>

                      <mat-icon
                        *ngIf="!isPointsCard || rewards?.length === 0"
                        class="status-icon"
                        style="color: var(--app-timber); cursor: pointer"
                        (click)="openRewardDialog()"
                        >add_circle</mat-icon
                      >
                    </div>

                    <div
                      class="form-field-label"
                      style="margin-bottom: 0px"
                      *ngIf="
                        rewards?.length &&
                        (isStampCard || rewards?.length === 0)
                      "
                    >
                      Edit Icon
                    </div>
                  </div>

                  <div
                    *ngFor="let item of rewards; let i = index"
                    style="margin-top: 10px"
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          justify-content: space-between;
                          margin-right: 20px;
                        "
                        class="social-container"
                      >
                        <div style="display: flex; align-items: center">
                          <div
                            class="form-field-label"
                            style="
                              margin-bottom: 0px !important;
                              color: black;
                              font-size: 16px;
                              margin-right: 5px;
                            "
                          >
                            {{ isStampCard ? item?.stamp : item?.points }}:
                          </div>
                          <div
                            class="form-field-label"
                            style="
                              margin-bottom: 0px !important;
                              color: black;
                              font-size: 16px;
                            "
                          >
                            {{ item?.reward?.title }}
                          </div>
                        </div>

                        <div
                          style="display: flex; align-items: center; gap: 5px"
                        >
                          <mat-icon
                            style="color: var(--app-timber); cursor: pointer"
                            (click)="editReward(item)"
                            >edit
                          </mat-icon>
                          <mat-icon
                            style="color: red; cursor: pointer"
                            (click)="removeReward(item)"
                            >cancel
                          </mat-icon>
                        </div>
                      </div>

                      <div
                        *ngIf="isStampCard"
                        style="cursor: pointer"
                        (click)="openIconPickerDialog(true, true, item)"
                      >
                        <mat-icon
                          *ngIf="!customRewardImage(item)"
                          class="icon"
                          [fontSet]="
                            customRewardIcon(item)?.filled
                              ? 'material-icons'
                              : 'material-icons-outlined'
                          "
                          >{{ customRewardIcon(item)?.web }}</mat-icon
                        >
                        <img
                          *ngIf="customRewardImage(item)"
                          style="width: 25px; height: 25px"
                          [src]="customRewardImage(item)"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="rewards?.length === 0"
                    style="color: #666; font-style: italic; margin-top: 20px"
                  >
                    No rewards configured. Click the + icon to add one.
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="Terms">
              <div class="col-lg-8">
                <div class="form-field" style="margin-top: 20px">
                  <div class="form-field-label">
                    Terms & Conditions<span
                      ><info-icon [text]="termsTooltip"></info-icon>
                    </span>
                  </div>

                  <app-text-editor
                    #termsEditor
                    [html]="html"
                    (htmlChange)="html = $event"
                  ></app-text-editor>
                </div>
              </div>
            </mat-tab>

            <mat-tab label="More">
              <div class="col-lg-8">
                <div class="form-field" style="margin-top: 20px">
                  <div class="form-field-label">
                    Post-Acquisition Popup<span
                      ><info-icon
                        text="Configure what happens after a customer takes your loyalty card"
                      ></info-icon>
                    </span>
                  </div>

                  <div style="margin-top: 20px">
                    <mat-slide-toggle
                      [formControl]="postAcquisitionEnabledFormControl"
                      color="primary"
                    >
                      Show popup after card acquisition
                    </mat-slide-toggle>
                  </div>

                  <div *ngIf="postAcquisitionEnabledFormControl.value">
                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">Icon</div>
                      <div style="display: flex; margin-top: 10px">
                        <div
                          class="colour-container"
                          style="margin-right: 20px"
                        >
                          <div
                            class="icon-avatar"
                            (click)="openPostAcquisitionIconDialog()"
                          >
                            <mat-icon
                              class="icon"
                              [fontSet]="
                                postAcquisitionIcon?.filled
                                  ? 'material-icons'
                                  : 'material-icons-outlined'
                              "
                              >{{ postAcquisitionIcon?.web }}</mat-icon
                            >
                          </div>
                          <div class="colour-label">Popup Icon</div>
                        </div>
                      </div>
                    </div>

                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">
                        Title<span style="color: red">*</span>
                      </div>
                      <input
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. Welcome to our loyalty programme!"
                        [formControl]="postAcquisitionTitleFormControl"
                        type="text"
                        [ngStyle]="{
                          border:
                            postAcquisitionTitleFormControl.invalid && submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      />
                    </div>

                    <div class="form-field" style="margin-top: 20px">
                      <div class="form-field-label">
                        Description<span style="color: red">*</span>
                      </div>
                      <textarea
                        class="form-input"
                        autocomplete="off"
                        placeholder="e.g. Start earning rewards with every purchase"
                        [formControl]="postAcquisitionDescriptionFormControl"
                        rows="3"
                        [ngStyle]="{
                          border:
                            postAcquisitionDescriptionFormControl.invalid &&
                            submitted
                              ? '1px solid red'
                              : '1px solid var(--app-light-grey)',
                        }"
                      ></textarea>
                    </div>

                    <div style="margin-top: 20px">
                      <app-primary-button
                        title="Preview Popup"
                        [disabled]="false"
                        (tapped)="previewPostAcquisitionPopup()"
                        border="1px solid var(--app-timber)"
                        bgColor="white"
                        color="var(--app-timber)"
                      ></app-primary-button>
                    </div>

                    <div>
                      <div class="form-field" style="margin-top: 20px">
                        <div class="form-field-label">
                          Button Title<span style="color: red">*</span>
                        </div>
                        <input
                          class="form-input"
                          autocomplete="off"
                          placeholder="e.g. View Offers"
                          [formControl]="postAcquisitionActionTitleFormControl"
                          type="text"
                          [ngStyle]="{
                            border:
                              postAcquisitionActionTitleFormControl.invalid &&
                              submitted
                                ? '1px solid red'
                                : '1px solid var(--app-light-grey)',
                          }"
                        />
                      </div>

                      <div class="form-field" style="margin-top: 20px">
                        <single-select
                          label="Action Type"
                          [formCtrl]="postAcquisitionActionTypeFormControl"
                          [options]="postAcquisitionActionTypeOptions"
                          property="label"
                          [value]="postAcquisitionActionTypeFormControl.value"
                          [inBrackets]="'subtitle'"
                          (selected)="postAcquisitionActionTypeSelected($event)"
                        ></single-select>
                      </div>

                      <div
                        class="form-field"
                        style="margin-top: 20px"
                        *ngIf="
                          postAcquisitionActionTypeFormControl.value?.value ===
                          'url'
                        "
                      >
                        <div class="form-field-label">
                          URL<span style="color: red">*</span>
                        </div>
                        <input
                          class="form-input"
                          autocomplete="off"
                          placeholder="e.g. https://example.com/offers"
                          [formControl]="postAcquisitionActionUrlFormControl"
                          type="url"
                          [ngStyle]="{
                            border:
                              postAcquisitionActionUrlFormControl.invalid &&
                              submitted
                                ? '1px solid red'
                                : '1px solid var(--app-light-grey)',
                          }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <div *ngIf="selectedTab == 'stamps'" style="margin-top: 20px">
          <app-info-box
            [title]="howToTitle"
            [body]="howToBody"
            [canDismiss]="false"
          ></app-info-box>
        </div>
      </div>

      <card-preview-container
        *ngIf="!(isHandset$ | async)"
        [textColour]="textColorFormControl.value"
        [cardColour]="cardColorFormControl.value"
        [stampColour]="stampFillColorFormControl.value"
        [stampFillEmpty]="stampFillEmptyFormControl.value"
        [stampOutlineColour]="stampColorFormControl.value"
        [stamps]="stampArray"
        [stampIcon]="stampIcon"
        [rewardIcon]="rewardIcon"
        [rewardIcons]="rewardIcons"
        [rewards]="rewards"
        [title]="titleFormControl.value"
        [description]="descriptionFormControl.value"
        [iconOpacity]="opacitySliderValue / 10"
        [iconColor]="iconColorFormControl.value"
        [showLogo]="showLogo"
        [showStamps]="showStamps"
        [shape]="shape"
        [cardGradient]="cardGradient ?? undefined"
        [stampImage]="stampImage?.content ?? card.stampImage?.url"
        [rewardImage]="rewardImage?.content ?? card.rewardImage?.url"
        [backgroundImage]="
          backgroundImage?.content ?? card.backgroundImage?.url
        "
        [backgroundImageOpacity]="bgImageOpacityValue / 10"
        [merchantLogo]="merchantLogo"
        [cardType]="cardTypeFormControl.value?.value"
        [currentPoints]="(totalPointsFormControl.value ?? 300) * 0.65"
        [totalPoints]="totalPointsFormControl.value ?? 300"
        [maxPoints]="maxPointsFormControl.value"
        [progressBarColor]="progressBarFormControl.value"
        [progressBarBgColor]="progressBarBgFormControl.value"
        [(bgImageOpacityValue)]="bgImageOpacityValue"
        [selectedTabIndex]="selectedIndex"
      ></card-preview-container>
    </div>
  </div>
</form>

<loader [loading]="loading"></loader>

<mat-menu #colorMenu="matMenu" class="custom-menu">
  <!-- Solid color option -->
  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px; position: relative"
    (click)="cardColorPicker.click(); $event.stopPropagation()"
  >
    <div style="display: flex; align-items: center; cursor: pointer">
      <div
        style="
          width: 15px;
          height: 15px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: var(--app-timber);
        "
      ></div>
      <span style="font-size: 14px">Solid</span>
    </div>

    <!-- Hidden native color input -->
    <input
      #cardColorPicker
      type="color"
      [value]="cardColorFormControl.value"
      (input)="onColorInput($event, cardColorFormControl)"
      style="
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
        pointer-events: none;
      "
    />
  </button>

  <!-- Gradient option -->
  <button
    class="menu-list-item"
    style="border-radius: 5px"
    mat-menu-item
    (click)="openGradientDialog()"
  >
    <div
      style="
        display: flex;
        justify-content: start;
        align-items: center;
        position: relative;
      "
    >
      <div
        style="
          width: 15px;
          height: 15px;
          border-radius: 50%;
          font-size: 14px;
          margin-right: 5px;
          background-image: linear-gradient(
            45deg,
            var(--app-timber),
            var(--app-beachy)
          );
        "
      ></div>
      <span style="font-size: 14px">Gradient</span>
    </div>
  </button>
</mat-menu>

<mat-menu #stampOutlineMenu="matMenu" class="custom-menu">
  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px; position: relative"
    (click)="colorPickerInput.click(); $event.stopPropagation()"
  >
    <div style="display: flex; align-items: center; cursor: pointer">
      <div
        style="
          width: 15px;
          height: 15px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: var(--app-timber);
        "
      ></div>
      <span style="font-size: 14px">Select Colour</span>
    </div>

    <!-- Hidden input: Not display:none so color picker appears correctly -->
    <input
      #colorPickerInput
      type="color"
      [value]="stampColorFormControl.value"
      (input)="onColorInput($event, stampColorFormControl)"
      style="
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
        pointer-events: none;
      "
    />
  </button>

  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px"
    (click)="stampColorFormControl.setValue(null)"
  >
    <span style="font-size: 14px">No Colour</span>
  </button>
</mat-menu>

<mat-menu #stampFillMenu="matMenu" class="custom-menu">
  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px; position: relative"
    (click)="stampFillColorPicker.click(); $event.stopPropagation()"
  >
    <div style="display: flex; align-items: center; cursor: pointer">
      <div
        style="
          width: 15px;
          height: 15px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: var(--app-timber);
        "
      ></div>
      <span style="font-size: 14px">Select Colour</span>
    </div>

    <!-- Hidden color input -->
    <input
      #stampFillColorPicker
      type="color"
      [value]="stampFillColorFormControl.value"
      (input)="onColorInput($event, stampFillColorFormControl)"
      style="
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
        pointer-events: none;
      "
    />
  </button>

  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px"
    (click)="stampFillColorFormControl.setValue(null)"
  >
    <span style="font-size: 14px">No Colour</span>
  </button>
</mat-menu>

<mat-menu #stampFillEmptyMenu="matMenu" class="custom-menu">
  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px; position: relative"
    (click)="stampFillEmptyColorPicker.click(); $event.stopPropagation()"
  >
    <div style="display: flex; align-items: center; cursor: pointer">
      <div
        style="
          width: 15px;
          height: 15px;
          border-radius: 50%;
          margin-right: 8px;
          background-color: var(--app-timber);
        "
      ></div>
      <span style="font-size: 14px">Select Colour</span>
    </div>

    <!-- Hidden color input -->
    <input
      #stampFillEmptyColorPicker
      type="color"
      [value]="stampFillEmptyFormControl.value"
      (input)="onColorInput($event, stampFillEmptyFormControl)"
      style="
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: -1;
        pointer-events: none;
      "
    />
  </button>

  <button
    class="menu-list-item"
    mat-menu-item
    style="border-radius: 5px"
    (click)="stampFillEmptyFormControl.setValue(null)"
  >
    <span style="font-size: 14px">No Colour</span>
  </button>
</mat-menu>
